import RenameDocumentModal from './RenameDocumentModal';

export default RenameDocumentModal;

